import { useEffect } from 'react';
import { trackError } from '../utils/gtm';

/**
 * Custom hook to track global errors and unhandled promise rejections.
 * It attaches event listeners to the window object.
 */
const useErrorTracker = () => {
  useEffect(() => {
    // Handler for runtime errors
    const handleOnError = (message, source, lineno, colno, error) => {
      // Use the error object if available, otherwise construct one
      const errorObj = error || new Error(message);
      
      trackError(errorObj, {
        type: 'runtime_error',
        fatal: false, // runtime errors caught here usually don't crash the whole app immediately if React handles them, but this listener is global
      });
      
      // We don't prevent default behavior (console logging), so return false
      return false;
    };

    // Handler for unhandled promise rejections
    const handleUnhandledRejection = (event) => {
      const reason = event.reason;
      const errorObj = reason instanceof Error ? reason : new Error(String(reason));

      trackError(errorObj, {
        type: 'unhandled_rejection',
        fatal: false,
      });
    };

    window.addEventListener('error', handleOnError);
    window.addEventListener('unhandledrejection', handleUnhandledRejection);

    return () => {
      window.removeEventListener('error', handleOnError);
      window.removeEventListener('unhandledrejection', handleUnhandledRejection);
    };
  }, []);
};

export default useErrorTracker;
